import { Component } from '@verndale/core';
import { createFocusTrap } from 'focus-trap';

import focusableElements from '../utils/focusable-elements';
import keys from '../utils/keys';

class Modal extends Component {
  setupDefaults() {
    this.dom = {
      $openButton: document._$(`[data-triggers="${this.el.id}"]`),
      $closeButtons: this.el._$$('.modal__close-button'),
      $backdrop: this.el._$('.modal__backdrop')
    };

    this.focusTrap = createFocusTrap(this.el);
  }

  addListeners() {
    this.el._on('keydown', ::this.handleKeydown);
    this.dom.$openButton?._on('click', ::this.handleOpenModalClick);
    this.el._on('openModal', ::this.handleOpenModalEvent);
    this.dom.$closeButtons._on('click', ::this.closeModal);
    this.dom.$backdrop._on('click', ::this.closeModalOnClickOutside);
  }

  handleOpenModalClick({ target }) {
    this.dom.$triggerElement = target;
    this.openModal();
  }

  handleOpenModalEvent({ detail }) {
    this.dom.$triggerElement = detail?.trigger;
    this.openModal();
  }

  handleKeydown({ keyCode }) {
    if (keyCode === keys.escape) {
      this.closeModal();
    }
  }

  closeModalOnClickOutside(e) {
    if (e.target !== this.dom.$backdrop) return;
    this.closeModal();
  }

  openModal() {
    const focusableModalElements = this.el._$$(focusableElements);
    focusableModalElements.forEach((element) =>
      element.setAttribute('tabindex', '0')
    );
    this.el.setAttribute('aria-hidden', 'false');
    this.focusTrap.activate();

    if (focusableModalElements.length) {
      focusableModalElements[0].focus();
    }
  }

  closeModal() {
    const focusableModalElements = this.el._$$(focusableElements);
    this.focusTrap.deactivate();
    focusableModalElements.forEach((element) =>
      element.setAttribute('tabindex', '-1')
    );
    this.el.setAttribute('aria-hidden', 'true');

    this.dom?.$triggerElement.focus();
  }
}

export default Modal;
